module.exports = {
	"LOAD_GAME_FAILED": {
		"title": "Game Error",
		"msg": "The Game you are trying to open is temporarily unavailable. Please try again in a few moments.",
		"fatal": true,
		"showServerMsg": true,
		"buttons": [
			{
				"textKey": "Reload game",
				"action": "reload"
			},
			{
				"textKey": "Home",
				"action": "home"
			}
		]
	},
	"LOAD_CONFIG_FAILED": {
		"title": "Game Error",
		"msg": "Game does not exist. Please try another title.",
		"fatal": true,
		"showServerMsg": true
	},
	"WAITING_ON_BALANCE": {
		"title": "Retrieving Balance",
		"msg": "Temporary problem. Please wait.",
		"fatal": false,
		"showServerMsg": true
	},
	"WAITING_ON_BALANCE_FAILED": {
		"title": "Temporary Problem",
		"msg": "Please load the game again.",
		"fatal": false,
		"showServerMsg": true,
		"buttons": [
			{
				"textKey": "Reload game",
				"action": "reload"
			}
		]
	},
	"NO_TICKETS_LEFT": {
		"code": 112,
		"title": "No tickets left...",
		"msg": "The next big win could be just around the corner. Get more tickets now.",
		"fatal": true,
		"showServerMsg": false,
		"buttons": [
			{
				"textKey": "Okay",
				"action": "hide-error"
			},
			{
				"textKey": "Get more tickets",
				"action": "buy-more"
			},
			{
				"textKey": "Home",
				"action": "home"
			}
		]
	},
	"INSUFFICIENT_FUNDS": {
		"code": 112,
		"title": "Oops",
		"msg": "You have insufficient funds",
		"fatal": true,
		"showServerMsg": false,
		"buttons": [
			{
				"textKey": "Okay",
				"action": "hide-error"
			},
			{
				"textKey": "Deposit",
				"action": "cashier"
			},
			{
				"textKey": "Home",
				"action": "home"
			}
		]
	},
	"PLACE_BET_FAILED": {
		"title": "Game Error",
		"msg": "Bet was not placed. Please try again.",
		"fatal": false,
		"showServerMsg": true,
		"buttons": [
			{
				"textKey": "Okay",
				"action": "hide-error"
			},
			{
				"textKey": "Quit",
				"action": "home"
			}
		]
	},
	"WAITING_ON_NOTIFICATION": {
		"title": "Placing Bet",
		"msg": "This is taking longer than expected. Please wait.",
		"fatal": false,
		"showServerMsg": true
	},
	"GAME_QUIT": {
		"title": "Game Quit",
		"msg": "You have quit the game.",
		"fatal": true,
		"showServerMsg": true
	},
	"REPLAY_START": {
		"title": "Last round not finished",
		"msg": "The previous unseen round will now be replayed",
		"fatal": false,
		"showServerMsg": true,
		"buttons": [
			{
				"textKey": "Okay",
				"action": "start-replay"
			}
		]
	},
	"REPLAY_DONE": {
		"title": "Replay finished",
		"msg": "Your replay has finished, you will now return to game",
		"fatal": false,
		"showServerMsg": true,
		"buttons": [
			{
				"textKey": "Okay",
				"action": "back-to-menu"
			}
		]
	},
	"REALITY_CHECK": {
		"title": "Hello there!",
		"msg": "",
		"fatal": false,
		"showServerMsg": false,
		"buttons": [
			{
				"text": "Continue",
				"action": "hide-reality-check"
			},
			{
				"text": "History",
				"action": "history"
			},
			{
				"text": "Quit",
				"action": "home"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./config/errors.yaml
// module id = 52
// module chunks = 3